import { NavLink, Outlet, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { Storefront, Receipt, UserCircle } from "@phosphor-icons/react";

// iter 251: Home tab removed — login lands on Catalog; 3 tabs only.
const TABS = [
  { to: "/m/catalog", key: "tab_catalog", icon: Storefront, testId: "mobile-tab-catalog" },
  { to: "/m/quotes", key: "tab_quotes", icon: Receipt, testId: "mobile-tab-quotes" },
  { to: "/m/profile", key: "tab_profile", icon: UserCircle, testId: "mobile-tab-profile" },
];

export default function MobileShell() {
  const location = useLocation();
  const { t } = useTranslation();

  return (
    <div className="mobile-app min-h-screen w-full" data-testid="mobile-app-shell">
      <div className="mx-auto max-w-lg min-h-screen relative bg-[#FAFAF9]">
        {/* iter 265: no AnimatePresence mode="wait" — a stalled exit animation
            (fast double-tap between tabs) left the new tab blank until refresh.
            Entrance-only fade keyed by route is enough. */}
        <motion.main
          key={location.pathname}
          initial={{ opacity: 0, y: 6 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.18, ease: "easeOut" }}
          className="pb-24 min-h-screen"
        >
          <Outlet />
        </motion.main>

        <nav
          className="fixed bottom-0 inset-x-0 mx-auto max-w-lg safe-bottom z-40 border-t border-[#E7E5E4] bg-white/80 backdrop-blur-xl"
          data-testid="mobile-bottom-nav"
        >
          <div className="grid grid-cols-3">
            {TABS.map(({ to, key, icon: Icon, testId }) => (
              <NavLink
                key={to}
                to={to}
                data-testid={testId}
                aria-label={t(`mobile.${key}`)}
                className={({ isActive }) =>
                  `press-scale flex flex-col items-center justify-center gap-0.5 min-h-[56px] py-1.5 transition-colors duration-200 ${
                    isActive ? "text-[#1E3A8A]" : "text-[#78716C]"
                  }`
                }
              >
                {({ isActive }) => (
                  <>
                    <Icon size={22} weight={isActive ? "duotone" : "regular"} />
                    <span className="text-[11px] font-medium">{t(`mobile.${key}`)}</span>
                  </>
                )}
              </NavLink>
            ))}
          </div>
        </nav>
      </div>
    </div>
  );
}
